import { render, staticRenderFns } from "./concactObtain.vue?vue&type=template&id=06cae62c&scoped=true"
import script from "./concactObtain.vue?vue&type=script&lang=js"
export * from "./concactObtain.vue?vue&type=script&lang=js"
import style0 from "./concactObtain.vue?vue&type=style&index=0&id=06cae62c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cae62c",
  null
  
)

export default component.exports